// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"7f4cb6d5","121":"0d7db856","154":"03685d6d","228":"d273ced4","299":"67a3c805","406":"d818a849","649":"ca17ad7d","819":"ab4b2512","842":"92d7bb88","901":"a75b782a"}[chunkId] + ".chunk.js";
};